<template>
  <svg :width="width" :height="height" viewBox="0 0 20 19" :fill="color" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 0C4.48602 0 2.68774e-05 4.03733 2.68774e-05 9C2.68774e-05 10.735 0.549026 12.4153 1.58936 13.868C1.39236 16.047 0.864359 17.6647 0.0976934 18.431C-0.00363978 18.5323 -0.0289731 18.6873 0.0350268 18.8153C0.0920267 18.9297 0.20836 19 0.33336 19C0.348693 19 0.36436 18.999 0.380026 18.9967C0.515026 18.9777 3.65102 18.526 5.91902 17.2173C7.20735 17.737 8.57935 18 10 18C15.514 18 20 13.9627 20 9C20 4.03733 15.514 0 10 0Z" fill="#80B7FF"/>
  </svg>
</template>

<script>
import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 16 },
    height: { type: [Number, String], default: 14 },
    color: { type: String, default: colors.iconColor }
  },
  name: "IconGroupChat"
}
</script>